function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTicket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#4AB8F7"
    },
    cx: 256,
    cy: 256,
    r: 256
  })))))))))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#368DCF"
    },
    d: "M512,256c0-12.787-0.951-25.351-2.761-37.636L450.375,159.5L61.625,186l36.771,36.771l-36.771,4.854   l24.737,24.737L61.625,269.25l23.453,23.453l-23.453,18.172l27.816,27.816L61.625,352.5l156.739,156.739   C230.649,511.049,243.213,512,256,512C397.385,512,512,397.385,512,256z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M450.375,186v-26.5H61.625V186h7.313c4.177,0,7.562,3.386,7.562,7.563l0,0    c0,4.177-3.386,7.563-7.562,7.563h-7.313v26.5h7.313c4.177,0,7.562,3.386,7.562,7.563l0,0c0,4.177-3.386,7.563-7.562,7.563h-7.313    v26.5h7.313c4.177,0,7.562,3.386,7.562,7.563l0,0c0,4.177-3.386,7.563-7.562,7.563h-7.313v26.5h7.313    c4.177,0,7.562,3.386,7.562,7.563l0,0c0,4.177-3.386,7.563-7.562,7.563h-7.313v26.5h388.75V326h-7.313    c-4.177,0-7.563-3.386-7.563-7.563l0,0c0-4.177,3.386-7.563,7.563-7.563h7.313v-26.5h-7.313c-4.177,0-7.563-3.386-7.563-7.563l0,0    c0-4.177,3.386-7.563,7.563-7.563h7.313v-26.5h-7.313c-4.177,0-7.563-3.386-7.563-7.563l0,0c0-4.177,3.386-7.563,7.563-7.563    h7.313v-26.5h-7.313c-4.177,0-7.563-3.386-7.563-7.563l0,0c0-4.177,3.386-7.563,7.563-7.563H450.375z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E9EDF5"
    },
    d: "M443.063,269.25h7.313v-13.345H61.625v13.345h7.313c4.177,0,7.563,3.386,7.563,7.563    c0,4.177-3.386,7.563-7.563,7.563h-7.313v26.5h7.313c4.177,0,7.563,3.386,7.563,7.563c0,4.177-3.386,7.563-7.563,7.563h-7.313    v26.5h388.75V326h-7.313c-4.177,0-7.563-3.386-7.563-7.563c0-4.177,3.386-7.563,7.563-7.563h7.313v-26.5h-7.313    c-4.177,0-7.563-3.386-7.563-7.563C435.5,272.636,438.886,269.25,443.063,269.25z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 104,
    y: 186,
    style: {
      fill: "#FFC200"
    },
    width: 204.793,
    height: 140
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 104,
    y: 255.905,
    style: {
      fill: "#FF8B00"
    },
    width: 204.793,
    height: 70.095
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 343,
    y: 186,
    style: {
      fill: "#2B4160"
    },
    width: 68,
    height: 20
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 343,
    y: 216,
    style: {
      fill: "#2B4160"
    },
    width: 68,
    height: 20
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 343,
    y: 246,
    style: {
      fill: "#2B4160"
    },
    width: 68,
    height: 20
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 343,
    y: 255.905,
    style: {
      fill: "#414952"
    },
    width: 68,
    height: 10.095
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 343,
    y: 276,
    style: {
      fill: "#414952"
    },
    width: 68,
    height: 20
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 343,
    y: 306,
    style: {
      fill: "#414952"
    },
    width: 68,
    height: 20
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "197.811,208.367 213.288,239.727 247.896,244.755 222.853,269.165 228.765,303.633     197.811,287.36 166.857,303.633 172.769,269.165 147.727,244.755 182.334,239.727   "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E9EDF5"
    },
    points: "247.896,244.755 213.288,239.727 197.811,208.367 197.75,208.491 197.75,287.392     197.811,287.36 228.765,303.633 222.854,269.165   "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicket);
export default __webpack_public_path__ + "static/media/ticket.cfb9fcb5b7234f698ca0f35feb314fcb.svg";
export { ForwardRef as ReactComponent };